const {NftCollection} = require("./NftCollection.js");
const {NftItem} = require("./NftItem.js");
const {NftMarketplace} = require("./NftMarketplace.js");
const {NftSale} = require("./NftSale.js");

module.exports.default = {
    NftCollection,
    NftItem,
    NftMarketplace,
    NftSale
};